<template>
  <li class="works-item" @click="bindWorkItem(grandInfo.works_id)">
    <span class="works-item-image"><img :src="grandInfo.works_img" alt="" style="width:100%;height:100%;"></span>
    <div class="works-item-content">
      <span class="works-item-content-title">{{grandInfo.works_name}}</span>
      <div class="works-item-content-bottom">
        <span class="works-item-content-bottom-flag">{{grandInfo.domain_name}}</span>
        <div class="pv" v-if="grandInfo.works_pv != undefined">
          <img src="../assets/image/view-icon.png" alt="" class="box-item-image">
          <span class="box-item-txt">{{grandInfo.works_pv}} </span>
        </div>
        <div class="count">
          <img src="../assets/image/star-solid.png" alt="" class="count-image" v-if="grandInfo.is_like == 1"/>
          <img src="../assets/image/star-hollow.png" alt="" class="count-image" v-else/>
          <span class="count-txt">{{grandInfo.like_num}}</span>
        </div>
      </div>
    </div>
  </li>
</template>
<script>
export default {
  props: {
    grandInfo: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    // 点击item
    bindWorkItem (worksId) {
      this.$router.push({
        name: 'WorkDetail',
        params: {
          id: worksId
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
.works-item{
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  //width: 186px;
  //height: 221px;
  width: 246px;
  height: 321px;
  cursor: pointer;
  margin-right:15px;
  &-image{
    //width: 186px;
    //height: 156px;
    width: 246px;
    height: 256px;
    background: #ccc;
  }
  &-content{
    padding: 12px 12px 0;
    width: 100%;
    height: 64px;
    background: #F1F1F1;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &-title{
      height: 14px;
      font-size:14px;
      font-weight:400;
      color:rgba(0,0,0,1);
    }
    &-bottom{
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 20px;
      &-flag{
        font-size:12px;
        font-weight:400;
        color:rgba(193,102,19,1);
      }
      .count{
        display: flex;
        align-items: center;
        &-image{
          margin-right: 4px;
          height: 20px;
          width: 20px;
        }
        &-txt{
          font-size:14px;
          font-weight:400;
          color:rgba(0,0,0,1);
        }
      }
    }
  }
}
.pv{
  display: flex;
  align-items: center;
  img{
    height: 20px;
    width: 20px;
    margin-right: 4px;
  }
}
</style>
